export default __webpack_public_path__ + "static/media/Medium Freeze Bomb.3d85936b.PNG";